module.exports = __webpack_public_path__ + "static/media/pinkAanalysis.87015df7.svg";